import { PropTypes } from "aem/ComponentWrapper";

export default {
  title: "Intl Email Subscribe Form",
  type: "rh/components/content/intl-email-subscription-form",
  config: {
    emptyLabel: "Intl Email Subscribe Form",
    isEmpty: ({ title }: PropTypes) => !title
  }
};
